<app-content-modal>
  <app-momo-criteria-step [insideModal]="true" [criteria]="criteria"></app-momo-criteria-step>
</app-content-modal>
